import styled from "styled-components";
import {Link} from "react-router-dom";

const TopPadding = styled.div`
  height: 5rem;
`;

const ProductPanel = styled.div`
  position: relative;
  margin: ${(props) => props.margin};
  width: 100%;
  padding-left: ${(props) => props.padding || '16px'};
`;

const ListHeaderTitle = styled.div`
  color: ${(props) => props.app_home_list_item_title_color ? props.app_home_list_item_title_color : "black"};
  overflow: hidden;
  display: ${(props) => props.hide ? 'none' : '-webkit-box'};
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 16px;
`;

const ListSubTitle = styled.div`
  color: ${(props) => props.app_home_list_item_subtitle_color ? props.app_home_list_item_subtitle_color : "gray"};
  font-weight: normal;
  margin: ${(props) => props.haveImage ? "0px 20px 20px 0" : "0px 20px 20px 0"};
  display: -webkit-box;
  -webkit-box-orient: vertical;  
  font-size: 12px;
  word-break: break-word;
  font-family: 'Open Sans','Montserrat',sans-serif;
  white-space: break-spaces;
`;

const Item = styled.li`
  border-bottom: ${(props) => props.thickness ? props.thickness + "px solid #e3e3e3" : "2px solid #e3e3e3"};
  padding: 1em;
`;

const StyledLink = styled(Link)`
    text-decoration: none;

    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
    }
`;

const ItemWrap = styled.div`
  overflow: hidden;
`
const ImageItem = styled.div`
  width: ${(props) => props.has_image ? '120px' : ''};
  height: ${(props) => props.has_image ? '120px' : ''};
  flex: ${(props) => props.has_image ? '0 0 120px' : ''};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.has_image && props.color ? props.color : ""};
  background-color: ${(props) => props.has_image && props.backgroundColor ? props.backgroundColor : ""};
`;

const ImageBag = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

export { TopPadding, ProductPanel, ListHeaderTitle, ListSubTitle, Item,
  StyledLink, ItemWrap, ImageItem, ImageBag };
